export default "__VITE_ASSET__20b85894__"